import { render, staticRenderFns } from "./BrutalOtpInput.vue?vue&type=template&id=b565209c&scoped=true&"
import script from "./BrutalOtpInput.vue?vue&type=script&lang=js&"
export * from "./BrutalOtpInput.vue?vue&type=script&lang=js&"
import style0 from "./BrutalOtpInput.vue?vue&type=style&index=0&id=b565209c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b565209c",
  null
  
)

export default component.exports